<template>
  <div>
    <template v-for="(item, key) in categories">
      <div class="aedw-package-section" :key="key">
        <span class="aedw-package-section-name">{{ item.tagline || item.name }}</span>

        <PackageList
          :useCustomTemplate="useCustomTemplate"
          :templateName="templateName"
          :config="config"
          :params="setCategory(item.id)"
          :useDefaultGridCols="useDefaultGridCols"
          :disableGetPackagesOnRender="disableGetPackagesOnRender"
        />
      </div>
    </template>
  </div>
</template>

<style lang="scss">
.aedw-package-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.aedw-package-section-name {
  font-size: 24px;
  font-weight: bold;
  color: #555555;
  text-align: center;
}
</style>

<script>
import PackageList from "./package-list.vue";

export default {
  components: { PackageList },

  props: [
    "categories",
    "useCustomTemplate",
    "templateName",
    "config",
    "useDefaultGridCols",
    "params",
    "disableGetPackagesOnRender"
  ],

  methods: {
    setCategory(categoryId) {
      return {
        ...this.params,
        category_list: categoryId,
      };
    },
  },
};
</script>